import terms from '../register/privacy/Kayttoehdot-UnitSpotter_20180925.pdf'
import gdpr from '../register/privacy/Tietosuojaseloste-UnitSpotter.pdf'

function openInNewTab(url: any) {
    const win = window.open(url, '_blank');
    if (win != null){
        win.focus();
    }
}

export const openHelp = () => {
    openInNewTab("/help");
}

export const openTerms = () => {
    openInNewTab(terms);   
}

export const openPrivacy = () => {
    openInNewTab(gdpr)
}


// WEBPACK FOOTER //
// ./src/terms/termsHelpers.ts